export const ChrSelectTemplates = {
  OverflowTemplate: {
    menuPortalTarget: document.body,
    styles: {
      menuPortal: (base) => ({ ...base, zIndex: 2031 }),
      menu: (base) => ({ ...base, wordWrap: "break-word" })
    },
    menuPosition: 'absolute',
    menuPlacement: 'auto',
    menuShouldScrollIntoView: false
  }
};

export const ChrDatePickerTemplates = {
  OverflowTemplate: {
    calendarClass: "z-index-5 position-absolute"
  }
}